import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogTitle from '@mui/material/DialogTitle';
import { FC } from 'react';
import { DialogContent, DialogContentText } from '@mui/material';
import { CloudUpload } from '@mui/icons-material';
import { VisuallyHiddenInput } from 'ui/VisuallyHiddenInput';
import { TUploadProFormaDialogProps } from './types';

export const UploadProFormaDialog: FC<TUploadProFormaDialogProps> = ({
	open,
	setClose,
	handleConfirm,
	title = '',
	text = '',
	children = null,
}) => {
	return (
		<Dialog
			open={open}
			onClose={setClose}
			sx={{
				'& .MuiDialog-paper': {
					width: '500px',
					maxWidth: '500px',
					borderRadius: '12px',
				},
			}}
		>
			<DialogTitle color="primary" dangerouslySetInnerHTML={{ __html: title }} />
			<DialogContent>
				<DialogContentText>
					{text}
					{children}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button onClick={setClose}>Cancel</Button>
				<Button
					component="label"
					role={undefined}
					// variant="contained"
					color="primary"
					size="small"
					tabIndex={-1}
					startIcon={<CloudUpload />}
					autoFocus
				>
					Upload
					<VisuallyHiddenInput type="file" onChange={handleConfirm} />
				</Button>
			</DialogActions>
		</Dialog>
	);
};
